import { render, staticRenderFns } from "./SubMenuToolsPortrait.vue?vue&type=template&id=45180214&"
import script from "./SubMenuToolsPortrait.vue?vue&type=script&lang=js&"
export * from "./SubMenuToolsPortrait.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuToolsPortrait.vue?vue&type=style&index=0&id=45180214&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports